import { useEffect, useState } from "react";
import CustomSeparator from "../../Services/BreadcrumbsComponent";
import { PageInfo } from "../PageInfo";
import { useLocation } from "react-router-dom";
import { WebService } from "../../Services/WebService";
import { StandardConst } from "../../Services/StandardConst";
import ReactTimeAgo from "react-time-ago";
import { CloudDownload } from "@mui/icons-material";

function ViewNotification() {
  PageInfo({ pageTitle: "View Notifications" });

  const [Attachments, setAttachments] = useState([]);
  const [notificationData, setNotification] = useState({});
  const location = useLocation();
  const notification = location.state?.notification || {};
  const MasterPageName = "View Notification";

  const [bData, setBData] = useState([
    { title: "Company", hrefLink: "#" },
    { title: "Sales", hrefLink: "#" },
  ]);

  const FetchNotificationAttachments = async () => {
    try {
      const response = await WebService({
        endPoint: `CommonUtility/fetchAll/NotificationAttachments?NotificationId=${notification.NotificationId}`,
        method: "get",
      });

            setAttachments(response);

       const Notificationresponse = await WebService({
        endPoint: `Notification/getOneNotification/${notification.NotificationId}`,
        method: "get",
      });


      setNotification(Notificationresponse[0]);
      console.log("Notification response:", Notificationresponse);
    } catch (e) {
      console.error("Error fetching notification attachments:", e);
    }
  };

  useEffect(() => {
    FetchNotificationAttachments();
  }, []);

  const getFileName = (url) => url.split("/").pop();

  const isPreviewable = (type) => {
    return (
      type.startsWith("text/") ||
      type.startsWith("image/") ||
      type.startsWith("video/") ||
      type === "application/json"
    );
  };

  const renderPreview = (file) => {
    const fullUrl = `${StandardConst.apiBaseUrl}/uploads/${file.AttachmentUrl}`;

    if (file.AttachmentType.startsWith("image/")) {
      return (
        <img
          src={fullUrl}
          alt={getFileName(file.AttachmentUrl)}
          className="img-fluid rounded mb-2"
          style={{ maxHeight: "300px", objectFit: "contain" }}
        />
      );
    } else if (file.AttachmentType.startsWith("video/")) {
      return (
        <video
          controls
          className="w-100 rounded mb-2"
          style={{ maxHeight: "300px" }}
        >
          <source src={fullUrl} type={file.AttachmentType} />
          Your browser does not support the video tag.
        </video>
      );
    } else if (file.AttachmentType.startsWith("text/") || file.AttachmentType === "application/json") {
      return (
        <iframe
          src={fullUrl}
          title="Text Preview"
          className="w-100 bg-light rounded border mb-2"
          style={{ height: "200px" }}
        ></iframe>
      );
    }

    return <p className="text-muted fst-italic">Preview not available</p>;
  };

  const handleForceDownload = async (fileUrl, fileName = "downloaded-file") => {
  try {
    const response = await fetch(fileUrl, {
      mode: "cors",
    });

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Download failed:", error);
  }
};

  return (
    <div className="d-flex flex-column mt-3 h-full bg-white mx-2">
      <div>
        <h5 className="ms-2 mt-2">{MasterPageName}</h5>
      </div>
      <div className="ms-2 rounded-10">
        <CustomSeparator bData={bData} />
      </div>

      <div className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="mb-0">Notification Details</h6>
          <span className="text-muted">
            <ReactTimeAgo date={new Date(notification.CreatedOn)} />
          </span>
        </div>
        <h5>Send by: {notificationData.CreatedBy}</h5>
        <p>Message: {notificationData.Message}</p>
      </div>

      <div className="row row-cols-1 row-cols-md-2 g-3 px-3">
        {Attachments.map((file) => {
          const fileUrl = `${StandardConst.apiBaseUrl}/uploads/${file.AttachmentUrl}`;
          return (
            <div className="col" key={file.NotificationAttachmentsId}>
              <div className="card shadow-sm p-3 h-100">
                <h6 className="fw-bold mb-2">{getFileName(file.AttachmentUrl)}</h6>
                <p className="text-muted small mb-2">Type: {file.AttachmentType}</p>

                {isPreviewable(file.AttachmentType) && renderPreview(file)}

             <button
  onClick={() => handleForceDownload(fileUrl, "myfile")}
  className="btn btn-outline-primary btn-sm mt-auto d-inline-flex align-items-center gap-2"
>
  <CloudDownload fontSize="small" />
  Download
</button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ViewNotification;
